module.exports = __webpack_public_path__ + "img/84.3a3300c.png";